import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import blockIcon from "../../../../../assets/img/block-icon.svg";
import returnIcon from "../../../../../assets/img/modals/return.svg";
import { ChevronRight } from '../../../../../utils/svg';
import addFaqIcon from "../../../../../assets/img/products/add-faq-btn.svg";
import dotsIcon from "../../../../../assets/img/products/faq-dots.svg";
import removeicon from "../../../../../assets/img/products/removeicon.svg";
import CroppieModal from '../../../../croppie-modal';
import { hideLoader, showLoader } from '../../../../loader';
import ErrorMessage from '../../../../errors/errorMessage';
import AddVariableDropdown from './add-variable-dropdown';
import FontDropdown from './font-dropdown';

function Logo({data, showSectionChildModal, setShowSectionChildModal, error, setError, handleSubmit, handleUpdate }) {
    const close = () => setShowSectionChildModal(false);
    const [title, setTitle] = useState();
    // const [croppie, setCroppie] = useState(null);
    const [index, setIndex] = useState(null);
    const [selectedSize, setSelectedSize] = useState({
      'title_size': 4,
      });
    // const [showCroppieModal, setshowCroppieModal] = useState(null);
    // const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [logo, setLogo] = useState([
        {
          image: "",
          image_url: "",
        },
      ]);
    const [showInputIndex, setShowInputIndex] = useState(null);
    //   const handleopenmodal = (e,i) => {
    //     setIndex(i);
    //     setcroppie_image({ url: "", id: null, name: null, type: null });
    //     generate_image_preview(e.target);
    //     hideLoader();
    // };
      
  function handleadd() {
    var newdata = [...logo];
    newdata.push({image: "" ,image_url: "", });
    setLogo(newdata);
  }

  function handleDelete(i) {
    const newarr = [...logo];
    newarr.splice(i, 1);
    setLogo(newarr);
  }

  // const handleHideModal = () => {
  //   setshowCroppieModal(false);
  //   setCroppie(null);
  //   setcroppie_image({ url: "", id: null });
  //   // history.push(basePath + "/products");
  // };
  // const croppieClose = () => {
  //   showLoader();
  //   setshowCroppieModal(false);
  //   setCroppie(null);
  //   setTimeout(() => {
  //     hideLoader();
  //   }, 400);
  // };
  // const croppedImage = () => {
  //   if (croppie !== null) {
  //     croppie
  //       .result({
  //         type: "canvas",
  //         size: "original",
  //         format: "png",
  //         quality: 1,
  //       })
  //       .then((response) => {
  //         const tempObj = { image_url: response };
  //         croppie
  //           .result({
  //             size: "viewport",
  //             format: "png",
  //             quality: 1,
  //             type: "blob",
  //           })
  //           .then((res) => {
  //             const tempLogo = [...logo];
  //             const currentObj = { ...tempLogo[index] };
  //             if (currentObj) {
  //               currentObj.image = response;
          
  //                 currentObj.image_url = response;
                  
  //                 tempLogo[index] = currentObj;
  //                 setLogo([...tempLogo]);
  //             }
  //             croppieClose()
  //           });
  //       });
  //   }
  // };
  function removeImage(index,type) {
    const tempLogo = [...logo];
      const currentObj = { ...tempLogo[index] };
      if (currentObj) {
        if (type == 'image') {
          currentObj.image = null;
          currentObj.image_url = null;
        }else {
          currentObj.logo_url = null;
        }
        tempLogo[index] = currentObj;
        setLogo([...tempLogo]);
    }
  }
  // function generate_image_preview(input) {
  //   showLoader();
  //   if (input.files && input.files[0]) {
  //     let reader = new FileReader();
  //     if (input.files[0].size >= 5242880) {
  //       $("#image_file_input").val("");
  //       let notification_container = $(".notification-container");
  //       toast.error("File Size Should not exceed 5MBs");
  //       // showModal();
  //       return;
  //     }
  //     let val = input.files[0].name;
  //     let valid_extensions = ["png", "jpg", "jpeg"];
  //     let extension =
  //       val.substring(val.lastIndexOf(".") + 1, val.length) || val;
  //     if (!valid_extensions.includes(extension)) {
  //       $("#image_file_input").val("");
  //       let notification_container = $(".notification-container");
  //       toast.error("Invalid Image File. Should be png, jpg or jpeg");
  //       // showModal();
  //       return;
  //     }
  //     reader.onload = (event) => {
  //       setcroppie_image({
  //         ...croppie_image,
  //         url: event.target.result,
  //       });
  //       setshowCroppieModal(true);
  //       setTimeout(() => {
  //         const el = document.getElementById("image_demo2");
  //         try {
  //           console.log("el", el);
  //           if (el) {
  //             var croppieInstance = new Croppie(el, {
  //               enableExif: true,
  //               viewport: {
  //                 width: 850,
  //                 height: 300,
  //                 type: 'square',
  //                 showCroppieModal
  //               },
  //               boundary: {
  //                 width: 870,
  //                 height: 320
  //               },
  //             });
  //             croppieInstance
  //               .bind({
  //                 url: event.target.result,
  //               })
  //               .then(function () {
  //                 console.log("jQuery bind complete");
  //                 setTimeout(() => { }, 300);
  //               })
  //               .catch(() => {
  //                 croppieClose();
  //               });
  //             setCroppie(croppieInstance);
  //           }
  //         } catch { }
  //       }, 500);
  //     };
  //     reader.readAsDataURL(input.files[0]);
  //   }
  // }
  const handleValues = (a, i) => {
    const value = a.target.value;
    const name = a.target.name;
    const tempReview = [...reviews];
    const currentObj = { ...tempReview[i] };
    currentObj[name] = value;
    tempReview[i] = currentObj;
    setReviews([...tempReview]);
  };
  const handleFormAction = (update,e) => {
    const errors = [];
    const validLogo = logo.filter((data) => {
      if (!data?.image) {
          errors.push(`Image is required`);
          return false;
      }
      if (!title) {
        errors.push(`Title is required`);
        return false;
      }
      return data?.image
    });
    if (errors.length > 0) {
        setError(errors);
        return;
    }
    const formattedData = {
        title: title,
        logos: validLogo.map((logo) => ({
        image: logo?.image,
        logo_url: logo?.logo_url,
      })),
      title_size: selectedSize?.title_size ?? 4,
    };
  if (update) {
    handleUpdate(formattedData,'logo',e.target.dataset?.value)
  }else{ 
    handleSubmit(formattedData,'logo');
  }
  };
  // const handleUpdateData = (e) => {
  //   const errors = [];
  //   const validLogo = logo.filter((data) => {
  //       if (!data?.image) {
  //           errors.push(`Name is required`);
  //           return false;
  //       }
  //       return data?.image
  //     });
  //   if (errors.length > 0) {
  //       setError(errors);
  //       return;
  //   }
  //   const formattedData = {
  //       title: title,
  //       logos: validLogo.map((logo) => ({
  //       image: logo?.image
  //     })),
  //   };
  //   handleUpdate(formattedData,'logo',e.target.dataset?.value)
  // }
  useEffect(() => {
    if (data?.meta) {
        const metaObject = JSON.parse(data.meta);
        const { title, logos, title_size } = metaObject;
        setTitle(title);
        setLogo(logos);
        setSelectedSize({
          'title_size': title_size || 4,
        });
    }
  },[data?.meta])
  const addedVariable = (value,variable) => {
    if (variable == 'title') {
      setTitle(title ? `${title} ${value}` : value);
    }
  }
  const onfilechange = (e,i) => {
    setIndex(i);
    const fileList = e.target.files[0];
    var reader = new FileReader();

    reader.onload = function (event) {
      const tempLogo = [...logo];
      const currentObj = { ...tempLogo[i] };
      if (currentObj) {
        currentObj.image = event.target.result;
        currentObj.image_url = event.target.result;
  
          
          tempLogo[i] = currentObj;
          setLogo([...tempLogo]);
          // setIndex(null);
      }
    };
    reader.readAsDataURL(fileList);
}
const handleUrlBlur = (event, index) => {
  // if (event?.target?.value) {
    const tempLogo = [...logo];
    const currentObj = { ...tempLogo[index] };
    if (currentObj) {
      currentObj.logo_url = event?.target?.value;
      tempLogo[index] = currentObj;
      setLogo(tempLogo);
      // event.target.disabled = true;
    // }
  }
};
  const showUrlInput = (index) => {
    setShowInputIndex(index);
  };
  function autoResize(input,i) {
    if (input.value.length > 24) {
      let mainDiv = document.getElementById(`logo-input-main-${i}`);
      if (mainDiv) {
        input.style.width = "auto";
        input.style.width = input.scrollWidth + "px";
        mainDiv.style.width = "auto";
        mainDiv.style.width = (input.scrollWidth + 15) + "px";
      }
    }
  }
    return (
        <Modal centered show={showSectionChildModal} onHide={close}>
            <div className="modal-dialog-centered" role="document">
                <div className="modal-content">
                <div class="modal-header">
                      <span className='block-modal-headings'>
                      Edit Logo's Section
                      </span>
                      <button type="button" class="close" onClick={close} aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                    <div className="modal-body">
                        <form name="product_type" method="post" role="form">
                            <div className="notification-container"></div>
                            {/* <div className="form-group">
                                <img src={blockIcon} width="40px" alt="" />
                                <h4 className="productHead1 mt-15px">Edit Logo's Section</h4>
                            </div> */}
                            <ErrorMessage error={error} />
                       
                            <div className="form-group mt-20px">
                                  <div className='label-variable'>
                                    <label className="productlabels">
                                       Title
                                    </label>   
                                    <div className='d-flex gap-1 align-items-center'>
                                        <FontDropdown selectedSize={selectedSize} setSelectedSize={setSelectedSize} fontKey="title_size" />
                                        <AddVariableDropdown addedVariable={addedVariable} state={'title'}/>
                                      </div>
                                      </div>
                                    <div className='heading-input d-flex p-0 justify-content-between align-items-baseline zaapGlobal-input mt-10px'>
                                    <div className='heading-input-main d-flex w-100 '> 
                                    <input onChange={(a) => setTitle(a.target.value)} type="text" className="zaapGlobal-input text-dark " name="short_description" value={title} placeholder="Trusted by these and you soon! (Hopefully)"/>
                                    </div>
                                    </div>
                            </div>

                            {logo?.map((e, i) => {return (<div key={i}>
                                <div className="form-group mt-15px">
                                    <div className='qnaContainer' style={{padding:"10px"}}>
                                        <div className='w-85 d-flex gap-2 flex-wrap align-items-center'>
                                            {!e?.image_url && !e?.image ?
                                            <button type="button" className="mt-0 newGraybtn position-relative bg-white">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                                    </svg>Upload Logo
                                                    <input
                                                        type="file"
                                                        className="dropzone dropzone4 inset-0"
                                                        name="cover_image"
                                                        accept=".png,.jpg,.jpeg"
                                                        id="image_file_input"
                                                        onChange={(e)=>onfilechange(e,i)}
                                                    />
                                            </button>: null
                                              }
                                            {/* <div className="preview-zone hidden "></div> */}

                                            {/* <div> */}
                                                {
                                                e?.image_url || e?.image ? 
                                                <div className='d-flex align-items-center '>
                                                    <div>
                                                        <img className="prevImageU" src={e?.image_url ?? e?.image} />
                                                        {/* {console.log(e?.image,"e?.image_url")} */}
                                                    </div>
                                                    <div>
                                                        <img title='Remove Image' onClick={(e) => removeImage(i,"image")} src={removeicon} width={"22px"} style={{ padding: 4, cursor: "pointer" }} />
                                                    </div>
                                                </div>: null
                                                }
                                                <div id={`logo-input-main-${i}`} onClick={() => showUrlInput(i)} className={`mt-0 newGraybtn position-relative cursor-pointer`}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M6.38252 9.44272L5.61748 10.2078C4.56116 11.2641 2.84855 11.2641 1.79223 10.2078C0.735922 9.15146 0.735922 7.43884 1.79223 6.38252L2.55728 5.61748M9.44272 6.38252L10.2078 5.61748C11.2641 4.56116 11.2641 2.84855 10.2078 1.79223C9.15145 0.735922 7.43884 0.735922 6.38252 1.79223L5.61748 2.55728M4.1066 7.89339L7.8934 4.10659" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                  </svg>
                                                  {
                                                    showInputIndex === i ?
                                                    <>
                                                      <input 
                                                        type="url" 
                                                        className='logo-url-inp' 
                                                        name='logo_url' 
                                                        value={e?.logo_url} 
                                                        onChange={(event) => handleUrlBlur(event, i)}  
                                                        onBlur={(event) => {
                                                          if (event.target.value) { 
                                                            handleUrlBlur(event, i)
                                                            setShowInputIndex(null)
                                                          }
                                                        }}
                                                        onInput={(e)=>autoResize(e.target,i)}
                                                        placeholder='Enter URL'
                                                      />
                                                    </>
                                                      :
                                                    <button className='p-0 bg-transparent border-0 text-left' type="button">
                                                     {e?.logo_url ? e?.logo_url : 'Add URL'}
                                                    </button> 
                                                  }
                                                  </div>
                                              { e?.logo_url && e?.logo_url &&
                                                  <div className='d-flex align-items-center '>
                                                    <div>
                                                      <img title='Remove URL' onClick={(e) => removeImage(i,"logo")} src={removeicon} width={"22px"} style={{ padding: 4, cursor: "pointer" }} />
                                                    </div>
                                                  </div>
                                              }
                                            {/* </div> */}
                                        </div>
                                        {logo.length > 1 ? 
                                        <div className='remove-icon' title='Remove Logo' >
                                            <img src={removeicon} width={"13px"} style={{margin:'0 10px'}} onClick={(a) => handleDelete(i)}/>
                                        </div>
                                         : <></>}
                                        </div>
                                    </div>
                                </div>
                            );})}


                            <div className="mt-15px">
                                <button type="button" className="newGraybtn bg-f3f3f3 shadow-none" onClick={handleadd} width="100%">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                    </svg>
                                    <span className="me-2">Add Logo</span>
                                </button>
                            </div>
                            <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
                            <button type="button" onClick={close} class="fs-12 w-50 mt-0 integration-btns integration-btn-grey">
                               Cancel
                            </button>
                            <button data-value={data?.id} onClick={(e) => handleFormAction((data?.id ? true : false ),e)} type="button" class="fs-12 w-50 shadow-none  project-blue-btn ">
                                Save Changes
                            </button>
                        </div>
                            
                        </form>
                    </div>
                </div>
            </div>
            {/* <CroppieModal show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} /> */}

        </Modal>
    )
}

export default Logo